export const formatStatusDate = (isoString: string): string => {
    try {
        const date = new Date(isoString);

        // Option 1: Localized date and time
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        // Result: "Oct 25, 2025, 10:28 PM"

    } catch (error) {
        console.error('Error formatting date:', error);
        return 'Invalid Date';
    }
};

// For just the date part
export const formatDateOnly = (isoString: string): string => {
    try {
        const date = new Date(isoString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
        // Result: "Oct 25, 2025"
    } catch (error) {
        return 'Invalid Date';
    }
};

// For just the time part
export const formatTimeOnly = (isoString: string): string => {
    try {
        const date = new Date(isoString);
        return date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        // Result: "10:28 PM"
    } catch (error) {
        return 'Invalid Time';
    }
};

// Relative time (e.g., "2 days ago")
export const formatRelativeTime = (isoString: string): string => {
    try {
        const date = new Date(isoString);
        const now = new Date();
        const diffInMs = now.getTime() - date.getTime();
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

        if (diffInDays === 0) {
            return 'Today';
        } else if (diffInDays === 1) {
            return 'Yesterday';
        } else if (diffInDays < 7) {
            return `${diffInDays} days ago`;
        } else if (diffInDays < 30) {
            const weeks = Math.floor(diffInDays / 7);
            return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
        } else {
            return formatDateOnly(isoString);
        }
    } catch (error) {
        return 'Invalid Date';
    }
};

export interface DateDisplayProps {
    date: string | Date | undefined | null;
    prefix?: string;
    fallbackText?: string;
    formatOptions?: Intl.DateTimeFormatOptions;
}

export function formatDateDisplay (DateProps: DateDisplayProps): string {

    var formattedDate = DateProps.fallbackText ?? '';

    const prefix = DateProps.prefix ?? '';

    const dateFormat = DateProps.formatOptions ?? {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    };

    if (DateProps.date) {
        const whitespace = prefix.length > 0 ? " " : "";

        formattedDate = prefix + whitespace + new Date(DateProps.date).toLocaleDateString('en-US', dateFormat);
    }

    return formattedDate;
};

export function toIsoUtc(d: Date) {
    return d.toISOString();
}

export function startOfTodayUtc() {
    const now = new Date();
    return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0));
}

export function startOfDayUtc(d: Date) {
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 0, 0, 0));
}

export function endOfDayUtc(d: Date) {
    return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 23, 59, 59));
}
export function addDays(d: Date, days: number) {
    const copy = new Date(d.getTime());
    copy.setUTCDate(copy.getUTCDate() + days);
    return copy;
}